import { Component, Input } from '@angular/core';
// Services
import { RulesChangeService } from '../../services/rules-change.service';
// Models
import { RULE_WORKFLOW_SECTION } from '../../models/inline-rules.model';
import { RulesEvents } from '../../models/inline-rules.event';

@Component({
	selector: 'cv-schema-render-display-rule-information',
	templateUrl: './display-rule-information.component.html',
	styleUrls: ['./display-rule-information.component.scss']
})
export class DisplayRuleInformationComponent {
	@Input() ruleViolation: any;
	@Input() activeActions: any
	@Input() options: any;
	@Input() path: any;
	@Input() section: any;

	public ruleWorkflowSection = RULE_WORKFLOW_SECTION;

	constructor(
		private rulesChange: RulesChangeService
	) {
		//
	}

	/**
	 * Doc must exist
	 * @param ruleWorkflowSection 
	 * @param ruleViolation 
	 */
	changeRuleFlow(ruleWorkflowSection: RULE_WORKFLOW_SECTION, ruleViolation: any = null): void {
		this.rulesChange.rulesDataChanged.next({
			type: RulesEvents.CHANGE_RULE_FLOW,
			ruleWorkflowSection,
			ruleViolation,
			path: this.path
		})
	}

}
